import React from 'react';
import { Routes, Route } from 'react-router-dom';
import TasksPage from './TasksPage';
import TaskEditPage from './TaskEditPage';
import TaskChecklistPage from './TaskChecklistPage';

export { TaskRow, useTaskActions, useTasksChanged, checklistPath, occurrenceText, TASKS_CHANGED } from './taskActions';
export type { TaskActions } from './taskActions';
export { useSheets, dayOptionLabel } from './Sheet';
export type { SheetOption, Sheets } from './Sheet';

/** Pages under /casa/tarefas. */
const TasksRoutes: React.FC = () => (
  <Routes>
    <Route index element={<TasksPage />} />
    <Route path="nova" element={<TaskEditPage />} />
    <Route path="passos/:occurrenceId" element={<TaskChecklistPage />} />
    <Route path=":taskId" element={<TaskEditPage />} />
  </Routes>
);

export default TasksRoutes;
